module.exports = __webpack_public_path__ + "media/Video 142b.ff97651e.mp4";